export default "__VITE_ASSET__DsihC5D8__"